import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";
export const ChequeBookIteamPopup = (props) => {
    return (
        <ModalBasic
            id="cityMaster"
            classParams="!w-[55%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Bank details</span>
                <div className='item-grp grid grid-cols-3 gap-2.5 mt-3 mb-3 items-center'>
                    <div className='input-grp col-span-3'>
                        <label>Cheque Book No</label>
                        <TextInput type='text'
                            id='chequeBookNo' name='chequeBookNo'
                            value={props.itemObject.chequeBookNo}
                            handleChange={(event) => props.handleChangeForChequeBookItem(event, 'chequeBookNo')}
                            className={props.validState?.error?.chequeBookNo !== undefined ? "error" : ""}
                        />
                    </div>

                    <div className='input-grp col-span-2'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.itemObject.remarks}
                            handleChange={(event) => props.handleChangeForChequeBookItem(event, 'remarks')}
                        />
                    </div>
                    <div className='input-grp inline-flex gap-2.5 mt-4'>
                        <label>Is Cancel</label>
                        <TextInput type='checkBox'
                            id='isCancel' name='isCancel'
                            value={props.itemObject.isCancel}
                            handleChange={(event) => props.handleChangeForChequeBookItem(event, 'isCancel')}
                            className={`w-[15px] h-[15px] ${props.validState?.error?.isCancel !== undefined ? "error" : ""}`}
                            checked={props.itemObject.isCancel}
                        />
                    </div>
                    {/* <div className='input-grp col-span-2'>
                        <button className="save-btn btns mt-auto mb-[2px]" >Add</button>
                    </div> */}
                </div>



                <div className='btn-grp flex gap-2.5 mt-5'>
                    {props.itemObject.id > 0 ?
                        <button className="update-btn btns" onClick={() => props.insertItem(props.itemObject.id)}>Update</button>
                        :
                        <button className="update-btn btns" onClick={() => props.insertItem(0)}>Add</button>
                    }

                    {/* <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button> */}
                    {props.itemObject.id > 0 ?
                        <div className='btn-grp'>
                            <button className="delete-btn btns" onClick={() => props.deleteItem(props.itemObject.id)}>Delete</button>
                        </div>
                        : null
                    }
                </div>
            </div>

        </ModalBasic>
    )
}